import React from 'react'
import { useMemo } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';



const SubTable = ({data}) => {
    const columns = useMemo(
        () => [
          {
            accessorKey: 'branchName', //access nested data with dot notation
            header: 'اسم الفرع',
            size: 150,
          },

          {
            accessorKey: 'qty',
            header: 'الكمية ',
            size: 150,
            enableSorting: true,
          },
          {
            accessorKey: 'totalValue', 
            header: 'القيمة',
            size: 200,
          },
        ],
        [],
      );
    
      const table = useMaterialReactTable({
        columns,
        data,
        columnResizeDirection: 'rtl',
        initialState: {
          sorting: [{ id: 'qty', desc: true }], // Sort by 'lastName' ascending by default
        },
         //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
      });
    
      return (
        data.length>0?

      <MaterialReactTable table={table} />:
      <p>No sub rows available.</p>
    )
    };

export default SubTable